export default __webpack_public_path__ + "static/media/logo.05218121.svg";